import { below } from 'common/utils/breakpoint';
import { converRGBAalpha } from 'common/utils/colorConvert';
import { system800 } from 'common/components/Mui/styles/color';

export const backgroundType = ({ type = 1, color, imagePC, imageM, imageUrl }) => {
    let style = '';
    switch (type) {
        case 1:
            style = `
                background-color: ${color};
            `;
            break;
        case 2:
            style = `
                background-image: url('${imageUrl || imagePC}');
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
                ${below('sm')} {
                    background-image: url('${imageUrl || imageM}');
                }
            `;
            break;
        default:
            break;
    }
    return style;
};

export const convertStyle = ({ descColor, textBold, textColor, optionColor }) => {
    let titleStyle = textColor ? `color: ${textColor};` : '';
    titleStyle += textBold ? `font-weight: 500;` : '';

    let descStyle = descColor ? `color: ${descColor};` : '';
    let optionStyle = optionColor ? `background-color: ${optionColor};` : '';

    let optionAlphaStyle = {};
    if (optionColor) {
        optionAlphaStyle.generateOptionAlphaStyle = opacity =>
            converRGBAalpha(optionColor, opacity);
    }
    return { titleStyle, descStyle, optionStyle, ...optionAlphaStyle };
};

export const generateSectionStyle = ({
    descColor,
    textBold,
    textColor,
    answerColor,
    optionTextColor,
    optionBgColor
}) => {
    const displayNameStyle = {};
    const descStyle = {};
    const answerStyle = {};
    const optionStyle = {};
    if (textColor) {
        displayNameStyle.color = textColor;
    }
    if (textBold) {
        displayNameStyle.fontWeight = 500;
    }
    if (descColor) {
        descStyle.color = descColor;
    }
    answerStyle.color = answerColor || system800.color;
    if (optionTextColor) {
        optionStyle.color = optionTextColor;
    }
    if (optionBgColor) {
        optionStyle.backgroundColor = optionBgColor;
        optionStyle.borderColor = optionBgColor;
    }
    return { displayNameStyle, descStyle, answerStyle, optionStyle };
};
